import {Component} from '@theme/component';
import {StandardEvents, ProductSelectEvent} from '@shopify/events';
import {morph} from '@theme/morph';

/**
 * Displays a per-variant inventory notification metafield.
 * Mirrors ProductSkuComponent, but because variant metafields are not present
 * on the event's `resource` object, all variants' values are pre-rendered
 * server-side and this component toggles which one is visible by variant id.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} inventoryNotificationContainer - Parent to the rendered inventory notification elements.
 *
 * @extends {Component<Refs>}
 */
class InventoryNotificationComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect,
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect,
    );
  }

  /**
   * Handles product select event and updates variant inventory details.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    // Ignore events from product cards, which are handled by the card itself.
    if (
      !(event.target instanceof Element) ||
      event.target.closest('product-card')
    )
      return;

    event.promise
      .then(({detail}) => {
        if (!detail?.html) return;

        const {html, newProduct, resource} = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (
          detail.productId &&
          detail.productId !== this.dataset.productId
        ) {
          return;
        }

        const newInventoryNotification = html.querySelector(
          'inventory-notification-component',
        );

        if (!newInventoryNotification) return;

        morph(this, newInventoryNotification, {childrenOnly: true});

        // if (detail.productId && detail.productId !== this.dataset.productId)
        //   return;

        // if (resource) {
        //   const variantId = resource.id || '';

        //   // TK
        //   if (variantId) {
        //     console.log('tk:', variantId);
        //   }
        // }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError')
          console.warn(
            '[inventory-notification] Event promise rejected:',
            error,
          );
      });
  };
}

// Register the custom element if it hasn't been defined yet.
if (!customElements.get('inventory-notification-component')) {
  customElements.define(
    'inventory-notification-component',
    InventoryNotificationComponent,
  );
}
